<template lang="pug">
SspLayout(area="core")
  template(slot="actions")
    .form-group.m5
      input.form-control.group-filter(placeholder="Group filter" @input="onFilterInput($event.target.value)")

    router-link.btn.btn-primary(:to="{name: 'groupNew'}") New Group

  DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
    tr(slot="thead")
      th ID
      th Name
      th
    tr(v-for="g in groups")
      td {{g.id}}
      td {{g.name}}
        em.text-muted.space-before(v-if="g.parent") child of - {{g.parent.name}}
      td.actions
        router-link.btn-view(:to="{name: 'group', params: {id: g.id}}" title="View") View
        router-link.btn-edit(:to="{name: 'groupEdit', params: {id: g.id}}" title="Edit")
</template>

<script>
import debounce from 'debounce'
import DataGrid from '@/components/ssp/DataGrid'
import Security from '@/service/apis/Security'

export default {
  data() {
    return {
      groups: null,
      filter: null,
    }
  },
  created() {
    this.onFilterInput = debounce(this.onFilterInput, 200)
  },
  methods: {
    onFilterInput(filter) {
      this.filter = filter
      this.$refs.grid.reload(true)
    },
    fetchData(page) {
      const req = page.pageRequest()
      if (this.filter) {
        req.filter = this.filter
      }

      return Security.listGroups(req)
        .then((resp) => {
          this.groups = resp.data.content
          return resp.data.totalElements
        })
        .catch((e) => { this.$emit('error', e) })
    }
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/management/group/Groups.vue